import { Confirm } from '../../renderApp/components/cells/Confirm/Confirm';
import { makeEmptyScreenNavigate } from '../app/navigate';
import { navigateTo } from '../app/util';
import { preventEscape } from './preventEscape';

export const goLogin = async (url?: string) => {
  const confirmed = (await Confirm.open({
    title: ET('mps2::login::need_login::title'),
    message: preventEscape(ET('mps2::login::need_login::message')),
    confirmText: ET('mps2::login::login'),
    cancelText: ET('mps2::signup::close'),
  })) as boolean;

  if (confirmed) {
    return navigateTo(
      url ?? `/${T.lang}/@/login?url=${location.pathname + location.search}`,
      makeEmptyScreenNavigate,
    );
  }
};
